// extracted by mini-css-extract-plugin
export default {"main":"Snowflakes_main__YbD7x","initialHeart":"Snowflakes_initialHeart__UmClV","heart":"Snowflakes_heart__Nzqha","heartfall":"Snowflakes_heartfall__4JKGE"};